<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100">
    <div class="bg-white p-8 rounded-lg shadow-md w-full max-w-sm">
      <h2 class="text-2xl font-bold text-center mb-6">Admin Login</h2>

      <form @submit.prevent="handleLogin" class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700">Email</label>
          <input
            v-model="email"
            type="email"
            required
            class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:border-blue-500"
          />
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700">Password</label>
          <input
            v-model="password"
            type="password"
            required
            class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:border-blue-500"
          />
        </div>

        <button
          type="submit"
          class="w-full flex justify-center items-center gap-2 bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700"
        >
          <span>Login</span>
          <iconify-icon icon="mdi:login" class="text-xl" />
        </button>

        <p v-if="error" class="text-sm text-red-600 mt-2 text-center">{{ error }}</p>
        <p v-if="success" class="text-sm text-green-600 mt-2 text-center">{{ success }}</p>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { API_PATHS } from '@/utils/ApiPath.js';
import axios from 'axios';
// เพิ่ม
import { useRouter } from 'vue-router';

export default {
  name: 'LoginPage',
  setup() {
    const router = useRouter(); // <-- ประกาศ router
    const email = ref('');
    const password = ref('');
    const error = ref('');
    const success = ref('');

    const handleLogin = async () => {
      error.value = '';
      success.value = '';

      try {
        const res = await axios.post(API_PATHS.STAFF_LOGIN, {
          email: email.value,
          password: password.value,
        });

        success.value = res.data.message;
        // เรียก router.push ได้เลย
        router.push('/pheonix/dashboard');
      } catch (err) {
        error.value = err.response?.data?.message || 'Login failed';
      }
    };

    return { email, password, error, success, handleLogin };
  },
};
</script>

<style scoped>
/* เพิ่ม custom style ถ้าต้องการ */
</style>
